import { initialExpertiseConfiguration } from './ExpertiseConfigurationState';
import { ExpertiseWidgetType } from 'widgets/expertise/ExpertiseWidgetStrategy';
import { buildConfigReducerWithGridSupport } from 'widgets/store/grid/reducer';

export const expertiseConfigReducer = (widgetType: ExpertiseWidgetType) => {
    return buildConfigReducerWithGridSupport(
        widgetType,
        initialExpertiseConfiguration
    );
};
